import { useEffect, useState } from 'react';

export default function useKeyPress(targetKeyCode: 'ArrowLeft' | 'ArrowRight') {
  const [keyPressed, setKeyPressed] = useState<boolean>(false);

  function downHandler({ key }: KeyboardEvent) {
    if (key === targetKeyCode) setKeyPressed(true);
  }

  function upHandler({ key }: KeyboardEvent) {
    if (key === targetKeyCode) setKeyPressed(false);
  }

  useEffect(() => {
    if (typeof window === 'undefined') return;

    window.addEventListener('keydown', downHandler);
    window.addEventListener('keyup', upHandler);

    return () => {
      window.removeEventListener('keydown', downHandler);
      window.removeEventListener('keyup', upHandler);
    };
  }, []);

  return keyPressed;
}
